(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["row-column-panes"] && !window.DesignMode) return;
  try {
    
  // Check if certain sections should be visible
  $('[data-datecheck-start]').each(function(index) {
    var $elem = $(this);
    var startDate = $elem.data('datecheck-start');
    var endDate = $elem.data('datecheck-end');
    var currentDate = new Date();
    var checkDate = '';
    var itemShouldBeHidden = false;

    // Check if the start day or end day has passed
    if (startDate != '') {
      checkDate = new Date(startDate);
      if (currentDate < checkDate) {
        itemShouldBeHidden = true;
      }
    }
    if (endDate != '') {
      checkDate = new Date(endDate);
      if (currentDate > checkDate) {
        itemShouldBeHidden = true;
      }
    }

    // It can be visible, show the item
    if (itemShouldBeHidden == false) {
      $elem.removeClass('hidden');
    }
  });

  $(document).on('shopify:section:load', function() {
    $('[data-datecheck-start]').removeClass('hidden');
  });

  } catch(e) { console.error(e); }
})();

})();
